// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__b9Szu","footerFlexContainer":"Footer_footerFlexContainer__XQzgv","footerIcons":"Footer_footerIcons__lrHcR"};